/* import __COLOCATED_TEMPLATE__ from './footer-message.hbs'; */
import Component from "@ember/component";
import { classNames } from "@ember-decorators/component";

@classNames("footer-message")
export default class FooterMessage extends Component {}
